import { useState } from "react";
import { CheckCircle2 } from "lucide-react";
import { useI18n } from "@/contexts/I18nContext";
import { SUPPORTED_LOCALES, getStoredLocale, type Locale } from "@/lib/i18n";

export function LanguageSwitcher() {
  const { locale, setLocale } = useI18n();
  const [isAuto, setIsAuto] = useState(false);

  const handleSetLocale = (code: Locale) => {
    setIsAuto(false);
    setLocale(code);
  };

  const handleSetAuto = () => {
    setIsAuto(true);
    setLocale(getStoredLocale());
  };

  const btnBase =
    "relative flex items-center gap-2 px-4 py-2.5 rounded-xl border-2 text-sm font-medium transition-all duration-200";
  const activeClass = "border-[#C9A96E] bg-[#C9A96E]/8 text-[#8b6914] shadow-sm";
  const inactiveClass =
    "border-[#2D2D2D]/10 hover:border-[#2D2D2D]/20 bg-white text-[#2D2D2D]/70 hover:text-[#2D2D2D]";

  return (
    <div className="flex flex-wrap gap-2">
      {/* Default / Auto option */}
      <button
        onClick={handleSetAuto}
        className={`${btnBase} ${isAuto ? activeClass : inactiveClass}`}
      >
        {isAuto && (
          <CheckCircle2 className="absolute top-1.5 right-1.5 w-3 h-3 text-[#C9A96E]" />
        )}
        <span className="text-base">🌐</span>
        <span>Default</span>
      </button>

      {SUPPORTED_LOCALES.map(({ code, label, flag }) => (
        <button
          key={code}
          onClick={() => handleSetLocale(code as Locale)}
          className={`${btnBase} ${!isAuto && locale === code ? activeClass : inactiveClass}`}
        >
          {!isAuto && locale === code && (
            <CheckCircle2 className="absolute top-1.5 right-1.5 w-3 h-3 text-[#C9A96E]" />
          )}
          <span className="text-base">{flag}</span>
          <span>{label}</span>
        </button>
      ))}
    </div>
  );
}
